import {Typography, useTheme} from '@mui/material';
import IDay from './IDay';
import PersianDate from '@components/calendar/PersianDate';

interface IProps {
	day: IDay;
}

export default function CalendarBoardItem({day}: IProps) {
	const theme = useTheme();
	const color = day.isHoliday ? 'error.500' : (day.isToday ? 'white' : theme.palette.mode === 'light' ? 'grey.700' : 'grey.200');
	const bgcolor = day.isToday ? 'primary.main' : (day.isSelected ? 'secondary.100' : '');
	// let hijriDate = day.hijriDate;
	const hijriDate = new Date(day.date);
	// let hijriDate = day.date;
	hijriDate.setDate(hijriDate.getDate());
	// hijriDate.toLocaleDateString('ar-SA', {day: 'numeric'});
	return (
		<div onClick={day.setDate} style={{opacity: day.isDisabled ? '0.3' : '1'}}
		     className="flex flex-col items-center text-center h-12">
			<Typography sx={{color, bgcolor, padding: '1px'}}
			            className="font-bold rounded-full w-6 h-6">{day.date.toLocaleDateString('fa-IR', {day: 'numeric'})}</Typography>
			<div className="flex flex-row justify-center space-x-1 rtl:space-x-reverse">
				<Typography sx={{
					color: 'grey.400',
					fontSize: (theme) => theme.typography.fontSize - 4
				}}>{day.date.toLocaleDateString('en-GB', {day: 'numeric'})}</Typography>
				
				<Typography sx={{
					color: 'grey.400',
					fontSize: (theme) => theme.typography.fontSize - 4
				}}>
					{hijriDate.toLocaleDateString('ar-SA', {day: 'numeric'})}
					{/*{hijriDate.getHijriDate({day: 'numeric'})}*/}
					{/*{day.date.toLocaleDateString('ar-SA', {day: 'numeric'})}*/}
				</Typography>
			</div>
		</div>
	);
}
